import { actionCreators, IGlobalGroupsState } from '@app/store/modules/global'
import { bindFunctions } from '@app/utils/class'
import * as React from 'react'
import { Input } from 'reactstrap'

export interface IGroupFilterSelectorProps {
  bsSize?: 'lg' | 'sm'
  className?: string
  includeAll?: boolean
  name?: string
  onChange: (newType: string) => void
  required?: boolean
  style?: React.CSSProperties
  value: string
}

type GroupFilterSelectorProps = IGroupFilterSelectorProps &
  IGlobalGroupsState &
  typeof actionCreators

export class GroupFilterSelector extends React.PureComponent<
  GroupFilterSelectorProps
> {
  constructor(props: GroupFilterSelectorProps) {
    super(props)
    bindFunctions(this)
  }

  public componentDidMount() {
    this.props.getGroups()
  }

  public render() {
    return (
      <Input
        bsSize={this.props.bsSize}
        className={this.props.className}
        name={this.props.name}
        onChange={(e) => this.props.onChange(e.target.value)}
        required={this.props.required}
        style={this.props.style}
        type='select'
        value={this.props.value}
      >
        {this.props.includeAll === true && <option value=''>All</option>}
        {this.props.groups.map((group) => (
          <option key={group.groupId} value={group.name}>
            {group.name}
          </option>
        ))}
      </Input>
    )
  }
}
